import { memo } from "react";
import { Button } from "@/components/ui/button";
import {Logo} from "@/components/Logo";

const Navbar = memo(() => {
  return (
    <header>
      <nav className="bg-primary text-primary-foreground shadow-md">
        <div className="container mx-auto flex items-center justify-between min-h-24 gap-8 px-3">
          <a href="/" className="flex items-center gap-4">
            <Logo className="h-14" />
            <span className="hidden sm:inline-block font-semibold whitespace-nowrap self-center text-3xl">
              Greenhouse
            </span>
          </a>
          <div>
            <Button className="text-primary-foreground" variant="link" asChild>
              <a href="mailto:rirobinson@aarp.org">Reach out</a>
            </Button>
          </div>
        </div>
      </nav>
    </header>
  );
});

export { Navbar };
